import FundPropertiesTable from "./FundPropertiesTable"

export default FundPropertiesTable
